// Shared semantic tokens for selection controls (Checkbox, Radio) — single source of truth so both
// stay visually consistent. Sourced from the VUI v5 Figma "Checkbox"/"Radio" specs, verified against
// core/vuiProvider/consts.ts CSS variables.
export const selectionControlColors = {
  // No semantic read-only token yet; same sandstone step as before, expressed as a CSS var.
  readOnly: 'var(--vui-color-sandstone-30)',
  unchecked: 'var(--vui-control-border-default)',
  // Unchecked hover/pressed darken the border (no colour change); checked/indeterminate use the brand hover/pressed blue.
  uncheckedHover: 'var(--vui-control-border-hover)',
  checked: 'var(--vui-action-brand-solid)',
  hover: 'var(--vui-action-brand-solid-hover)',
  pressed: 'var(--vui-action-brand-solid-pressed)',
  focus: 'var(--vui-utility-focus)',
  // Colour of the mark drawn on top of a (checked/indeterminate) filled control, e.g. Checkbox's checkmark.
  mark: 'var(--vui-action-brand-solid-inverse)',
  label: 'var(--vui-control-label)',
  helper: 'var(--vui-control-helper)',
  error: 'var(--vui-action-danger-solid)',
} as const

export const selectionControlDisabled = {
  bg: 'var(--vui-action-disabled-background)',
  // Figma's disabled control has no separate border colour — it matches the background exactly.
  icon: 'var(--vui-action-disabled-background)',
  // The checked/indeterminate mark needs to stand out from the (near-white) disabled background.
  mark: 'var(--vui-action-disabled-foreground)',
  // Matches Figma `--control/foreground/disabled` (#9c9a96) — the semantic `--vui-control-foreground-disabled`
  // token has drifted (sandstone-20, far too dark), so the raw palette var is used instead.
  text: 'var(--vui-color-sandstone-60)',
} as const
